import React from 'react';
import PropTypes from 'prop-types';
import Separator from '@ublend-npm/aulaui-next-web/Separator';

import GroupListItem from './GroupListItem.container';
import { CompactList } from './Lists.styled';

const GroupsList = ({ groups }) => (
  <CompactList>
    {groups.map((groupId, idx) => {
      const separator = idx < groups.length - 1 ? <Separator /> : null;
      return (
        <React.Fragment key={groupId}>
          <GroupListItem group={groupId} />
          {separator}
        </React.Fragment>
      );
    })}
  </CompactList>
);

GroupsList.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default GroupsList;
